import * as m from 'mithril';

const LoadingIndicator: m.Component<{colorScheme?:string}> = {
    view: function(vnode) {
        let color = (vnode.attrs.colorScheme == null)? 'primary' : vnode.attrs.colorScheme;
        return m("div", {class: "d-flex justify-content-center", style:"height:100%"}, [
            m("div", {class: "align-self-center_ mt-5 pt-3 spinner-border text-" + color, role: "status"}, [
                m("span", {class: "sr-only"}, "Loading...")
            ])
        ])
    }
}

export default LoadingIndicator;